// extracted by mini-css-extract-plugin
module.exports = {"appLoading":"App_appLoading__3KXyH"};